import type { QueryClient } from "@tanstack/react-query";

/**
 * Every query root that caches whether a run still needs attention. Invalidated
 * as a set: a decision that refreshed only some of them leaves another
 * projection rendering a control for a run the server already resolved.
 */
export const ATTENTION_INBOX_QUERY_ROOTS = [
	"activity-feed",
	"notifications",
	"notifications-unread-count",
] as const;

/** Refetch attention state from the server after a decision, read, or delete. */
export function invalidateAttentionInbox(queryClient: QueryClient): void {
	for (const root of ATTENTION_INBOX_QUERY_ROOTS) {
		void queryClient.invalidateQueries({ queryKey: [root] });
	}
}
